import clsx from 'clsx';
import { PropsWithChildren } from 'react';
import styles from './BlockBadge.module.scss';

export type BlockBadgeProps = PropsWithChildren<{
  className?: string;
}>;

export const BlockBadge = ({ children, className }: BlockBadgeProps) => {
  const classes = clsx(styles.base, className);

  return <div className={classes}>{children}</div>;
};
